import * as React from 'react';
import HubspotForm from 'react-hubspot-form';
import cn from 'classnames';

import s from './single-field-form.module.scss';

export const SingleFieldHSForm: React.FC<{
  centered?: boolean;
  formInstanceId: string;
  id: string;
}> = ({ centered = false, id = '74cc89e5-ae76-4667-bed8-fcfcb3692ef1', ...rest }) => {
  const [formLoaded, setFormLoaded] = React.useState(false);

  return (
    <div className="relative h-52 sm:h-32 sm:min-w-[450px] w-full">
      <div className={cn(s.form, centered && s['form__centered'], formLoaded && s['form__loaded'])}>
        <HubspotForm
          onReady={() => setFormLoaded(true)}
          portalId="4823527"
          formId={id}
          {...rest}
          submitButtonClass="rounded-full w-full sm:w-auto bg-scale-mauve sm:ml-4 font-medium text-white px-4 py-2 cursor-pointer"
        />
      </div>
    </div>
  );
};
